import type { CollectionScope } from "@/interfaces/adminCollections";

const SCOPE_STYLES: Record<CollectionScope, string> = {
  PUBLIC: "bg-[#E0E3DD] text-[#637058]",
  INTERNAL: "bg-[#D0DCE6] text-[#2B4A60]",
};

export default function ScopeBadge({ scope }: { scope: CollectionScope }) {
  return (
    <span
      className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-bold tracking-wide ${SCOPE_STYLES[scope]}`}
    >
      {scope}
    </span>
  );
}
